import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { CustomAppsPage } from "src/components/views/ai/customApps/CustomAppsPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/customizations/custom-apps")({
	staticData: { title: i18n.t("manage_custom_apps"), legacyViewKey: "customAppsManagementPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <CustomAppsPage />;
}
